import * as React from "react"

import {
    Action,
    ActionAnchor,
    ActionType,
} from "@tenforce/toolbox-button-push-react"

import env from "../../../../env"
import { ButtonSymbols } from "../../../../symbols"

import ComponentButton from "./ComponentButton"
import { ActionTypeIds } from "../../../search/constants"
import { IButton } from "../../../common/contextmenu"

interface Props {
    button: IButton
    actionType: ActionType
    executeCallButton: (button: IButton) => void
    afterCall?: () => void
}

export default function Button({
    button,
    executeCallButton,
    actionType,
    afterCall,
}: Props): JSX.Element {
    const { buttonData, caption, icon, tooltip, isLoading, showCaption } =
        button
    const tooltipText = tooltip.length > 0 ? tooltip : caption

    const iconSymbol = ButtonSymbols.has(icon)
        ? `${ButtonSymbols.get(icon)}`
        : ""

    const content = (
        <>
            {iconSymbol}
            {!!iconSymbol && showCaption && <>&nbsp;</>}
            {showCaption && caption}
        </>
    )

    let extraClasses = isLoading ? "is-loading no-underline" : "no-underline"
    if (actionType === ActionType.block) {
        extraClasses += " text-black tw-px-2"
    }

    const isEllipsed =
        buttonData.type === "Call" &&
        ActionTypeIds.includes(buttonData.actionId)

    if (isEllipsed) {
        extraClasses += " is-ellipsed"
    }

    return (
        <>
            {buttonData.type === "Link" && (
                <ActionAnchor
                    actionType={actionType}
                    href={
                        buttonData.url[0] === "/"
                            ? env.applicationPath + buttonData.url
                            : buttonData.url
                    }
                    target={buttonData.opensNewTab ? "_blank" : ""}
                    extraClasses={extraClasses}
                    data-ft-component="headerButton"
                    data-ft-caption={caption}
                    id={buttonData.actionId}
                    title={tooltipText}
                >
                    {content}
                </ActionAnchor>
            )}

            {buttonData.type === "Call" && (
                <Action
                    actionType={actionType}
                    onClick={(): void => {
                        executeCallButton(button)
                        if (!!afterCall) {
                            afterCall()
                        }
                    }}
                    extraClasses={extraClasses}
                    data-ft-component="headerButton"
                    data-ft-caption={caption}
                    id={buttonData.actionId}
                    title={tooltipText}
                >
                    {content}
                </Action>
            )}

            {buttonData.type === "Component" && (
                <ComponentButton button={button} />
            )}
        </>
    )
}
